import React, { useEffect, useRef } from 'react';
import { Form } from "antd";
import { IMetaForm } from "../type/upload-document-modal.types";
import { buildFormElements } from "../utils/buildMetaFormELements";


const MetaForm: React.FC<IMetaForm> = (props) => {

    const timeoutRef = useRef<any>(null);
    const [form] = Form.useForm();

    useEffect(() => {
        form.resetFields();
    }, [props.metaData, props.uid]);


    return (
        <>
            {props.metaData.length > 0 && (
                <>
                    <Form
                        layout="vertical"
                        className={'upload-document-modal__meta-form'}
                        form={form}
                        onValuesChange={(changedValues, allValues) => {
                            clearTimeout(timeoutRef.current);

                            timeoutRef.current = setTimeout(() => {
                                if (props.uid) {
                                    props.handleMetaFormSubmit(props.uid, allValues);
                                } else {
                                    props.handleGlobalMetaData(allValues);
                                }
                            }, 300);
                        }}
                    >
                        {buildFormElements(props.metaData)}
                    </Form>
                </>
            )}
        </>
    )

}

export default MetaForm
